module.exports = __webpack_public_path__ + "static/media/socket.io.571d8a1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/socket.io.png
// module id = 192
// module chunks = 0